export default __webpack_public_path__ + "static/media/contactPerson.215b2bbf.png";